import { useContext } from 'react'
import { gnarSpec } from '@lib/tracking/gnar'
import { PageContext } from '../../../../contexts/page-context'
import { PlacementContext } from '../../../../contexts/placement-context'

export const useUseCaseTabsGnarTracking = () => {
  const { pageId, slug } = useContext(PageContext)
  const { placement, placementInternalName } = useContext(PlacementContext)

  const tabClick = (index: number, label: string) => {
    gnarSpec.tabButtonClick(pageId, slug, index, label, placement, placementInternalName)
  }

  return {
    tabClick,
  }
}
